import { Typography as T } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import { colors } from "../styles";

const CustomTableContainer = ({
  title,
  children,
  subtitle = "",
  containerComponent = Paper,
  noBorder = false,
}: {
  title: string;
  children: React.ReactNode;
  subtitle?: string;
  containerComponent?: React.ElementType;
  noBorder?: boolean;
}) => {
  return (
    <TableContainer
      component={containerComponent}
      sx={{
        boxShadow: 0,
        border: noBorder ? "none" : `1px solid ${colors.gray_01}`,
        filter: "drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.12))",
      }}
    >
      {title && (
        <div
          className="flex flex-col justify-center"
          style={{ height: subtitle ? 77 : 56, padding: 16 }}
        >
          <T variant="headingSm">{title}</T>
          {subtitle && (
            <T variant="mdMed" color={colors.gray_600}>
              {subtitle} Employees
            </T>
          )}
        </div>
      )}
      {children}
    </TableContainer>
  );
};

export default CustomTableContainer;
